
import pkHeader from '../common/header/header.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
components: {
Group,
Cell,
XButton,
pkHeader
},
created: function () {


},
methods: {
changeSetValue(){

var me =  this ,map =  this.map;
me.cityList = [];
var options = {
onSearchComplete: function(results){


me.cityList=[];
if (local.getStatus() == BMAP_STATUS_SUCCESS){
for (var i = 0; i < results.getCurrentNumPois(); i++) {

if(results.getPoi(i).type == "0"){
me.cityList.push(results.getPoi(i));
}

}
/*for(var i in results.wr){
if(results.wr[i].type == "0"){
me.cityList.push(results.wr[i]);
}
}*/
}

}
};
var local = new BMap.LocalSearch(map, options);
local.search(this.cityAddress);
},
selectedCity(item){
var flag = this.checkPoint(new BMap.Point(item.point.lng,item.point.lat), this.pointInPolygon);
if(!flag){

this.$vux.toast.show({
text: "此地点不在服务范围，请重新设置",
type:"text"
})

return;
}
var that =  this;

var  current={
point : item.point,
address:item.title || item.address,
cityName: item.city || item.addressComponents.city,
cityNo:that.cityNo
};

var jbStorage =  window.localStorage.getItem("jbStorage");
if(jbStorage){
jbStorage =  JSON.parse(jbStorage);
jbStorage.mapAddress =  current;
window.localStorage.setItem("jbStorage", JSON.stringify(jbStorage));
}else{
window.localStorage.setItem("jbStorage", JSON.stringify({"mapAddress":current}));
}

if(this.$until.judgeBrowser() == "weixin"){
setTimeout(()=>{
this.$router.push("/"+that.$store.state.mutations.path);
},300)
}else{
this.$router.push("/"+that.$store.state.mutations.path);
}

},
dragendMap(){

var center= this.map.getCenter(), that =  this;
var mPoint = new BMap.Point(center.lng,center.lat);
this.surroundings = [];
var geoc = new BMap.Geocoder();
var pointList =  [];
geoc.getLocation(mPoint, function(res){

that.currentPoint = {
"titleAddress": res.address,
"address" : res.surroundingPois.length?res.surroundingPois[0].title:res.address,
"addressComponents":res.addressComponents,
"point": res.surroundingPois.length ? res.surroundingPois[0].point: res.point
}
for(var a in res.surroundingPois){
if(a >= 10) return;


var point =  new BMap.Point(res.surroundingPois[a].point.lng,res.surroundingPois[a].point.lat);
pointList.push({
"title": res.surroundingPois[a].title,
"point":point,
address:res.surroundingPois[a].address
});
}
that.tabIndex = pointList;


for(var a in pointList){
that.getLocation(geoc,pointList[a].point, pointList[a].title);
}

if(!that.checkPoint(new BMap.Point(center.lng,center.lat))){
that.windowMsg =  "起点和本地址不在同一区域，请重新设置";
return;
}
that.windowMsg = that.currentPoint.address;
})
},
getLocation(geoc,pointList,title){
var that =  this;
geoc.getLocation(pointList, function(rs){
rs.title = title;
that.surroundings.push(rs);
});
},
dragstartMap(){

},
init: function () {
var city = this.Maincity;
var that  =  this;

this.map = new BMap.Map("container");
this.map.enableScrollWheelZoom(true);    
this.map.enableContinuousZoom(true);    
this.map.addControl(new BMap.NavigationControl());  
this.map.addEventListener("dragend",this.dragendMap);
this.map.addEventListener("dragstart",this.dragstartMap);
this.map.addEventListener("zoomend", this.dragendMap);

if(!this.$store.state.mutations.cityAddress){
that.cityNo = this.$store.state.mutations.cityNo;
}

if(this.$until.getUrlParam("cityNo")){
that.cityNo = this.$until.getUrlParam("cityNo");
}

let servr = this.$until.getUrlParam('ness')=='Air' ? 'queryAirPortServiceArea':'queryStationServiceArea'
console.log("vvv", this.$store.state.mutations.cityNo);
this.$http.post(window.innerAPI + "?server="+servr,{
"ip":that.cityNo ? "":"171.88.164.17",
"cityNo":that.cityNo,
"channelCode":localStorage.getItem('useCar_jb_channelCode')
}).then(data=>{

if(!data.data.msg && data.data.data.data){
var newData =  data.data.data.data;
var mapPointsList =  data.data.data.data.servicePoint[0];
var plys = [];



that.Maincity = {
"cityName": newData.cityName,
}
that.cityNo =  newData.cityNo;


if(!mapPointsList){that.setCurrent(1);return;}


if(!parseInt(that.label)){
var point = new BMap.Point(newData.initLongitude, newData.initLatitude);
that.map.centerAndZoom(point, 30);

that.setCurrent();
}else{
that.setCurrent(1);
}

if(mapPointsList.length>0){
for(var a in mapPointsList){
var pt= new BMap.Point( mapPointsList[a].longitude,mapPointsList[a].latitude);
plys.push(pt);
}
this.areaPoint =  plys;
var ply= new BMap.Polygon(plys,{strokeColor:"#eb3a3a",fillColor:"#eb3a3a",fillOpacity:0.1, strokeWeight:2, strokeOpacity:0.5});
this.pointInPolygon = ply;
this.map.addOverlay(ply);   
}
}else{


that.setCurrent(1);
}


}).catch(err=>{

})



},

setCurrent(flag){

var geolocation = new BMap.Geolocation(),that =  this;
geolocation.getCurrentPosition(function(r){

if(this.getStatus() == BMAP_STATUS_SUCCESS){

if(flag) {
that.map.centerAndZoom(r.point, 15);
that.Maincity = {
"cityName": r.address.city,
}
};                 // 初始化地图，设置中心点坐标和地图级别
var myIcon = new BMap.Icon("./static/mark_b.png", new BMap.Size(16,16));
var mk = new BMap.Marker(r.point,{icon:myIcon});
that.map.addOverlay(mk);

}
},{enableHighAccuracy: true})
},

checkPoint(pt){
return  BMapLib.GeoUtils.isPointInPolygon(pt, this.pointInPolygon);
},
backmethod(){
setTimeout(()=>{
this.$router.push("/"+this.$store.state.mutations.path);
},500);
},
selectCity(){

var newHref = location.hash.indexOf("?") == -1 ? location.hash : location.hash.substr(0, location.hash.indexOf("label"))+"label=0"
this.$router.push("/posi?back="+encodeURIComponent(newHref));
},

setMainCity(){

if(this.$store.state.mutations.cityAddress){

var jbStorage =  localStorage.getItem("jbStorage");

if(jbStorage &&JSON.parse(jbStorage).city){
this.Maincity =  {
"cityName": JSON.parse(jbStorage).city.name,
}
this.cityNo =  JSON.parse(jbStorage).city.id;
}
}
},
},
data () {
return {
results: [],
value: '',
autoFixed:true,
cityNo:'',  //传入的当前城市的cityNo
map:{},
path:'',
loaded: false,
cityAddress:"",
Maincity:{
"cityName":"成都"
},
docHeigh:document.body.clientHeight-45 -300 -51,
tabIndex: [],
cityList:[],
flag:'',
areaPoint:[],
windowMsg:'起点和本地址不在同一区域，请重新设置',
surroundings:[], //周边的地址
currentPoint:{},//当前点
pointInPolygon:{},
title: this.$until.getUrlParam("title"),
label: this.$until.getUrlParam("label") || (localStorage.getItem("$currentCity") == this.cityNo)
}
},
created() {
},
watch:{
cityAddress: function (val, oldVal) {

},
},
mounted(){
this.setMainCity();
this.init();

},
}



// WEBPACK FOOTER //
// ./src/components/pickGiveStation/arriveAddressB.vue